import { AbstractReportPmsApiService } from '../abstract-report.service';
import { NotesReport } from "../../../models/reports/daily-activity/notes.model";

/**
 * @class NotesReportPmsApiService
 * @extends {AbstractReportPmsApiService<NotesReport>}
 */
export class NotesReportPmsApiService extends AbstractReportPmsApiService {

    /**
     * @type {string}
     * @protected
     */
    get urlPattern() {

        return super.urlPattern + '/daily-activity/notes';
    }

    /**
     * @param {Object.<string, *>} attributes
     * @returns {NotesReport}
     * @protected
     */
    newModel(attributes, ...params) {

        return new NotesReport(attributes);
    }

    /**
     * @param {Property=} property
     * @returns {Promise.<Object>}
     */
    getConfiguration(property) {

        const url = this.url({propertyId: property.id}) + '/configuration';

        return this.http
            .get(url, {
                headers: this.authHeaders
            })
            .then(this.getDataExtractor())
            .catch(this.getErrorHandler());
    }

    /**
     * @param {Property} property
     * @param {Object} configuration
     * @returns {Promise.<Object>}
     */
    saveConfiguration(property, configuration) {

        const url = this.url({propertyId: property.id}) + '/configuration';

        return this.http
            .put(url, configuration, {
                headers: this.authHeaders
            })
            .then(this.getDataExtractor())
            .catch(this.getErrorHandler());
    }
}


// WEBPACK FOOTER //
// ./src/pms-api/services/reports/daily-activity/notes.service.js